/* import __COLOCATED_TEMPLATE__ from './lsg-new-posting-button.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import clsx from 'clsx';

class LsgNewPostingButton extends Component {
  @service
  router;
  
  @service
  session;

  get classNames() {
    return clsx(
      this.args.class,
      'SH-c-lsg-new-posting-button',
    );
  }

  /**
   * When the new posting is clicked on.
   */
  @action
  onNewPostingClicked() {
    const company = this.session.currentUser?.company;

    if (!company) {
      return;
    }

    this.router.transitionTo(EMBER_ROUTE_NAMES.POSTING__CREATE);
  }
}

export default LsgNewPostingButton;
